import React from 'react';
import { MdClose } from 'react-icons/md';

const ImageModal = ({ showModal, name, data, handleCancel }) => {
    return(
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content bg-transparent" style={{boxShadow: 'none'}}>
                        <div className="modal-header bg-transparent border-0 d-flex justify-content-end">
                            <button type="button" className="close rounded-xl bg-white text-dark p-2" aria-label="Close" onClick={handleCancel}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body d-flex flex-column align-items-center justify-content-center">
                            {data === null ? <img src={'/Assets/nopreview.png'} alt="Thumbnail" style={{width: '200px', height: '200px'}} />
                                : <img src={data} alt="Thumbnail" width="75%" height="75%" />}
                            <p className="mt-2 text-light">{(name.length > 20) ? name.slice(0,19) + '..' : name}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show" style={{opacity: 1}}></div>
        </div>
    );
};

export default ImageModal;